module.exports = __webpack_public_path__ + "static/media/google-logo.ecc84433.png";